import { Table } from 'antd'
import { FC } from 'react'
import { useParams } from 'react-router'
import { useDashboardParams } from 'core/queryParams/useDashboardParams'
import { selectedRunColumns } from 'pages/SpecFileDetails/selectedRunColumnsConfig'
import { useGetSpec } from 'lib/queries/useGetSpec/useGetSpec'

interface Props {
  fileName: string
}

const SpecFileData: FC<Props> = ({ fileName }) => {
  const { runId, projectName } = useParams<{
    runId: string
    projectName: string
  }>()

  const {
    query: { suite },
  } = useDashboardParams()

  const { data: spec, isLoading } = useGetSpec({
    suite,
    project: projectName,
    runId,
    specFile: fileName,
  })

  if (!projectName || !runId) {
    return null
  }

  return (
    <Table
      loading={isLoading}
      columns={selectedRunColumns({ suite, project: projectName, runId })}
      dataSource={spec?.tests}
      pagination={false}
      bordered
    />
  )
}

export default SpecFileData
